import { InventoryLocation } from "@kiosk/microservice.inventory.models";

export class KioskInventorySummaryModel {
  KioskToken: string;
  KioskName: string;
  Address: string;
  LockerCountSummary: string;
  Locations: InventoryLocation[];
}
